import * as actionTypes from './action-types'
import {
  ADD_VENDOR_MODAL,
  OPEN_SAVE_NEW_SEARCH_MODAL,
  RESEND_INVITATION_MODAL,
} from './constants'

export const openAddVendorModal = () => ({
  type: actionTypes.OPEN_ADD_VENDOR_MODAL,
  payload: ADD_VENDOR_MODAL,
})

export const openSaveNewSearchModal = () => ({
  type: actionTypes.OPEN_SAVE_NEW_SEARCH_MODAL,
  payload: OPEN_SAVE_NEW_SEARCH_MODAL,
})

export const closeModal = () => ({
  type: actionTypes.CLOSE_MODAL,
})

export const openResendInvitationModal = (id, email) => ({
  type: actionTypes.OPEN_RESEND_INVITATION_MODAL,
  payload: { email: email, id: id, open: RESEND_INVITATION_MODAL },
})
